var render = function () {
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('client-page', {
    staticClass: "wrap wrap--sub"
  }, [_c('sub-visual', {
    attrs: {
      "visual": "시설·장비예약"
    }
  }), _c('rental-navigation-row'), _c('section', {
    staticClass: "section"
  }, [_c('v-container', [_c('section', {
    staticClass: "page-section"
  }, [_c('tit-primary', {
    attrs: {
      "sc": "reservation",
      "tit": "예약 절차 안내",
      "titTxt": "전자제조지원센터는 장비 대여 및 시설 대관을 지원합니다. "
    }
  }), _c('h4', {
    staticClass: "tit--sm bar-txt"
  }, [_vm._v(" 장비 사용 ")]), _c('v-row', {
    staticClass: "row--large"
  }, [_c('v-col', {
    attrs: {
      "cols": "12",
      "sm": "6",
      "md": "4"
    }
  }, [_c('sub-step-card', {
    attrs: {
      "icon": "/images/sub/rental/intro/s1-icon1-1.svg",
      "step": "1",
      "tit": "장비 예약 신청",
      "sc1": "- 장비 예약에서 사용을 원하는 장비를 선택",
      "sc2": "- 대여 기간 및 신청폼 작성"
    }
  })], 1), _c('v-col', {
    attrs: {
      "cols": "12",
      "sm": "6",
      "md": "4"
    }
  }, [_c('sub-step-card', {
    attrs: {
      "icon": "/images/sub/rental/intro/s1-icon1-2.svg",
      "step": "2",
      "tit": "장비 예약 승인",
      "sc1": "- 관리자로 확인을 위한 절차 ",
      "sc2": "- 별도의 유선 및 메일로 연락이 필요할 수 있음"
    }
  })], 1), _c('v-col', {
    attrs: {
      "cols": "12",
      "md": "4"
    }
  }, [_c('sub-step-card', {
    attrs: {
      "icon": "/images/sub/rental/intro/s1-icon1-3.svg",
      "step": "3",
      "tit": "예약 완료",
      "sc1": "- 전자제조센터 장비 사용",
      "sc2": "- 사용 완료 후 사용료 지불 (관리자 협의)"
    }
  })], 1)], 1)], 1), _c('section', {
    staticClass: "page-section page-section--last"
  }, [_c('h4', {
    staticClass: "tit--sm bar-txt"
  }, [_vm._v(" 시설 사용 ")]), _c('v-row', {
    staticClass: "row--large"
  }, [_c('v-col', {
    attrs: {
      "cols": "12",
      "sm": "6",
      "md": "4"
    }
  }, [_c('sub-step-card', {
    attrs: {
      "icon": "/images/sub/rental/intro/s1-icon2-1.svg",
      "step": "1",
      "tit": "시설 예약 신청",
      "sc1": "- 시설 예약에서 예약을 원하는 시설 선택",
      "sc2": "- 시설 대관 목적, 대관 기간 폼 작성"
    }
  })], 1), _c('v-col', {
    attrs: {
      "cols": "12",
      "sm": "6",
      "md": "4"
    }
  }, [_c('sub-step-card', {
    attrs: {
      "icon": "/images/sub/rental/intro/s1-icon2-2.svg",
      "step": "2",
      "tit": "시설 예약 승인",
      "sc1": "- 관리자로 확인을 위한 절차 ",
      "sc2": "- 별도의 유선 및 메일로 연락이 필요할 수 있음"
    }
  })], 1), _c('v-col', {
    attrs: {
      "cols": "12",
      "md": "4"
    }
  }, [_c('sub-step-card', {
    attrs: {
      "icon": "/images/sub/rental/intro/s1-icon2-3.svg",
      "step": "3",
      "tit": "예약 완료",
      "sc1": "- 시설 담당자로부터 사용안내 방법 등 고지",
      "sc2": "- 시설 대관 완료 및 이용기간 내 이용 가능",
      "sc3": "- 대관 종료 후 시설 담당자에게 고지"
    }
  })], 1)], 1)], 1)])], 1)], 1);
}
var staticRenderFns = []

export { render, staticRenderFns }